import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { postJSON } from "./api";
import isEmpty from "./is-empty";
import { subscribeFail, subscribeSuccess } from "./subscriberAction";
import { SUBSCRIBE } from "./types";

const __URL__ = "https://agarilanding.herokuapp.com/subscribe";
// const __URL__ = "http://127.0.0.1:5000/subscribe";
function* subscribeUser(payload) {
  try {
    console.log("we are also here as well");
    console.log(`payload`, payload.params);
    const tripDetail = yield call(postJSON, __URL__, payload.params);

    yield put(subscribeSuccess(tripDetail));
  } catch (error) {
    if (!isEmpty(error.response)) {
      yield put(subscribeFail(error.response));
    }
  }
}

function* watchSubscribeUser() {
  yield takeEvery(SUBSCRIBE, subscribeUser);
}

function* dispatcherSaga() {
  yield all([fork(watchSubscribeUser)]);
}
export default dispatcherSaga;
